import { ClipboardList } from 'lucide-react';
import WidgetShell from '../WidgetShell';
import { useEcomStats } from '@/hooks/dashboard/useEcomDashboard';
import { cn } from '@/lib/utils';

const STATUSES: { key: keyof OrderCounts; label: string; color: string }[] = [
  { key: 'pending', label: 'Pending', color: 'text-yellow-600' },
  { key: 'processing', label: 'Processing', color: 'text-blue-600' },
  { key: 'shipped', label: 'Shipped', color: 'text-indigo-600' },
  { key: 'delivered', label: 'Delivered', color: 'text-green-600' },
  { key: 'cancelled', label: 'Cancelled', color: 'text-red-600' },
];

type OrderCounts = {
  pending: number;
  processing: number;
  shipped: number;
  delivered: number;
  cancelled: number;
};

export default function OrderStatusWidget() {
  const { data, isLoading, error } = useEcomStats();

  return (
    <WidgetShell
      title="Order Status"
      icon={<ClipboardList />}
      to="/admin/orders"
      isLoading={isLoading}
      error={error}
      skeletonClassName="h-20"
    >
      {data && (
        <div className="grid grid-cols-3 gap-4 sm:grid-cols-5">
          {STATUSES.map(({ key, label, color }) => (
            <div key={key} className="text-center">
              <p className={cn('text-2xl font-bold', color)}>
                {data.order_counts[key] ?? 0}
              </p>
              <p className="mt-1 text-xs text-stone-500">{label}</p>
            </div>
          ))}
        </div>
      )}
    </WidgetShell>
  );
}
